'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgTarget = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 239.97 239.95",
  height: 24,
  width: 24
}, props), _defs || (_defs = /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("style", null, ".cls-1{fill:currentColor}"))), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  className: "cls-1",
  d: "M0 119.77A119.89 119.89 0 0 1 120.26 0C187.31.16 240.15 54.93 240 120.1a120 120 0 1 1-240-.33zm20 .14c.42 55.4 44.42 100 100.08 100a99.92 99.92 0 0 0-.14-199.84c-55.4.03-99.51 44.42-99.94 99.84z"
})), _path2 || (_path2 = /*#__PURE__*/React__namespace.createElement("path", {
  className: "cls-1",
  d: "M119.89 200c-43.65.46-79.94-36.33-80-79.94s36.62-80.2 80.2-80.12c43.79.09 80.17 36.71 80 80.32-.22 43.82-36.65 80.22-80.2 79.74zm-1.26-20c32.82 1.19 60.48-25.85 61.42-58.46.95-32.87-26.24-60.74-58.33-61.63C88.8 59 60.74 86 59.89 118.29 59 151.15 86 179.77 118.63 180z"
})), _path3 || (_path3 = /*#__PURE__*/React__namespace.createElement("path", {
  className: "cls-1",
  d: "M119.88 80A40 40 0 1 1 80 120a40 40 0 0 1 39.88-40z"
})));

exports["default"] = SvgTarget;
